// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   PAGE SHELL
   min-height (not height) so tall forms scroll naturally, and the
   decorative background lives on a fixed layer so it always covers
   the whole viewport no matter how far you scroll.
   ========================================================= */
.login-page {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  display: flex;
  padding: 32px 16px;
  background: var(--background);
  isolation: isolate;
}

.login-page::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background:
    radial-gradient(60% 50% at 12% 8%, rgba(200, 16, 46, 0.14), transparent 70%),
    radial-gradient(55% 45% at 90% 92%, rgba(200, 16, 46, 0.10), transparent 70%),
    radial-gradient(40% 30% at 85% 10%, rgba(125, 10, 31, 0.06), transparent 70%);
}

[data-theme="dark"] .login-page::before {
  background:
    radial-gradient(60% 50% at 12% 8%, rgba(255, 113, 128, 0.16), transparent 70%),
    radial-gradient(55% 45% at 90% 92%, rgba(255, 113, 128, 0.10), transparent 70%),
    radial-gradient(40% 30% at 85% 10%, rgba(255, 145, 104, 0.06), transparent 70%);
}

/* =========================================================
   CARD
   margin: auto centers it when there's room and lets it grow
   (and scroll) from the top when there isn't.
   ========================================================= */
.login-card {
  position: relative;
  width: 100%;
  max-width: 420px;
  margin: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 20px;
  box-shadow: 0 24px 60px -12px var(--shadow-lg), 0 2px 6px var(--shadow);
  padding: 36px 34px 26px;
  overflow: hidden;
  animation: loginCardIn 0.45s cubic-bezier(0.22, 0.61, 0.36, 1) both;
}

/* brand accent strip */
.login-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary), var(--secondary));
}

.login-card.is-register {
  max-width: 460px;
}

@keyframes loginCardIn {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* each step re-mounts and fades in */
.login-step {
  animation: loginStepIn 0.32s ease both;
}

@keyframes loginStepIn {
  from { opacity: 0; transform: translateX(10px); }
  to   { opacity: 1; transform: translateX(0); }
}

/* =========================================================
   HEADER
   ========================================================= */
.login-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.login-brand-icon {
  width: 84px;
  height: 84px;
  object-fit: contain;
}

.login-title {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  text-align: center;
  margin: 0 0 6px;
  color: var(--text-primary);
}

.login-subtitle {
  font-size: 14px;
  text-align: center;
  color: var(--text-secondary);
  margin: 0 0 22px;
}

.login-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 6px;
}

/* =========================================================
   INPUTS
   ========================================================= */
.login-page .form-control {
  min-height: 46px;
  border-radius: var(--radius-md);
  background-color: var(--card-bg) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.login-page .form-control::placeholder {
  color: var(--text-muted);
}

.login-page .form-control:focus,
.login-page .form-select:focus {
  color: var(--text-primary);
  background-color: var(--card-bg) !important;
  border-color: var(--primary) !important;
  outline: 0;
  box-shadow: 0 0 0 0.25rem color-mix(in srgb, var(--primary) 20%, transparent);
}

.login-page .btn:focus,
.login-page .btn:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem color-mix(in srgb, var(--primary) 25%, transparent);
}

.login-hint {
  font-size: 12px;
  line-height: 1.5;
  color: var(--text-muted);
  margin: 0 0 16px;
}

.login-sent-to {
  font-size: 14px;
  color: var(--text-secondary);
  text-align: center;
  margin: 0 0 18px;
  word-break: break-word;
}
.login-sent-to strong {
  color: var(--text-primary);
}

.login-code-input {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.5em;
  padding-left: 0.5em;
}

/* =========================================================
   SUBMIT BUTTON
   ========================================================= */
.login-submit-btn {
  width: 100%;
  min-height: 48px;
  margin-top: 8px;
  font-weight: 700;
  letter-spacing: 0.01em;
  border-radius: var(--radius-md);
  transition: transform 0.08s ease, box-shadow 0.2s ease, background-color 0.2s ease;

  --cui-btn-bg: var(--primary);
  --cui-btn-border-color: var(--primary);
  --cui-btn-hover-bg: var(--primary-hover);
  --cui-btn-hover-border-color: var(--primary-hover);
  --cui-btn-active-bg: var(--primary-hover);
  --cui-btn-active-border-color: var(--primary-hover);
  --cui-btn-focus-shadow-rgb: var(--bs-primary-rgb);
}

.login-submit-btn,
.login-submit-btn:hover,
.login-submit-btn:active,
.login-submit-btn:focus,
.login-submit-btn:focus-visible {
  color: #fff !important;
}

.login-submit-btn {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  box-shadow: 0 8px 18px -8px color-mix(in srgb, var(--primary) 70%, transparent);
}

.login-submit-btn:hover,
.login-submit-btn:active,
.login-submit-btn:focus,
.login-submit-btn:focus-visible {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.login-submit-btn:active:not(:disabled) {
  transform: translateY(1px);
}

.login-submit-btn:disabled {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  opacity: 0.55;
  box-shadow: none;
}

/* =========================================================
   PASSWORD FIELD
   ========================================================= */
.password-input-wrapper {
  position: relative;
  margin-bottom: 1.25rem;
}

.password-input {
  padding-right: 44px;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  color: var(--text-secondary);
  cursor: pointer;
}
.password-toggle:hover { color: var(--text-primary); }
.password-toggle:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
  border-radius: 4px;
}

/* =========================================================
   LINKS / FOOTER
   ========================================================= */
.login-switch {
  text-align: center;
  font-size: 13px;
  color: var(--text-secondary);
  margin: 16px 0 0;
}

.login-switch-link {
  background: none;
  border: none;
  padding: 0;
  color: var(--primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.login-switch-link:hover { text-decoration: underline; }
.login-switch-link:disabled { opacity: 0.5; cursor: not-allowed; }

.login-footnote {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 24px -34px 0;
  padding: 14px 34px 0;
  border-top: 1px solid var(--border);
  font-size: 12px;
  color: var(--text-muted);
}
.login-footnote svg { color: var(--primary); flex-shrink: 0; }

/* =========================================================
   REGISTRATION PROGRESS (stepper)
   The line runs from the CENTER of the first dot to the CENTER of
   the last dot (inset = half of one column), so a fill of
   index / (steps - 1) lands exactly on the active dot.
   ========================================================= */
.reg-progress {
  margin: 0 0 26px;
  padding: 16px 16px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: color-mix(in srgb, var(--primary) 3%, var(--card-bg));
}

.reg-progress-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.reg-progress-now {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.reg-progress-now strong {
  margin-left: 8px;
  padding-left: 8px;
  border-left: 1px solid var(--border);
  color: var(--text-primary);
  letter-spacing: 0.02em;
}

.reg-progress-pct {
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--primary);
}

.reg-stepper {
  position: relative;
}

.reg-stepper-line {
  position: absolute;
  top: 10px; /* vertical center of the 20px dots */
  left: calc(100% / (var(--steps) * 2));
  right: calc(100% / (var(--steps) * 2));
  height: 4px;
  transform: translateY(-50%);
  border-radius: 999px;
  background: var(--border);
  overflow: hidden;
}

.reg-stepper-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--primary), var(--secondary));
  transition: width 0.6s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.reg-stepper-list {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(var(--steps), 1fr);
  margin: 0;
  padding: 0;
  list-style: none;
}

.reg-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.reg-step-dot {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--border);
  background: var(--card-bg);
  color: #fff;
  transition: background-color 0.3s ease, border-color 0.3s ease,
    box-shadow 0.3s ease;
}

.reg-step-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-align: center;
  white-space: nowrap;
  transition: color 0.3s ease;
}

/* completed */
.reg-step.is-complete .reg-step-dot {
  background: var(--primary);
  border-color: var(--primary);
}
.reg-step.is-complete .reg-step-label {
  color: var(--text-secondary);
}

/* current */
.reg-step.is-current .reg-step-dot {
  border-color: var(--primary);
  background: var(--card-bg);
  animation: regPulse 2s ease-out infinite;
}
.reg-step.is-current .reg-step-dot::after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--primary);
}
.reg-step.is-current .reg-step-label {
  color: var(--primary);
}

@keyframes regPulse {
  0%   { box-shadow: 0 0 0 0 color-mix(in srgb, var(--primary) 40%, transparent); }
  70%  { box-shadow: 0 0 0 8px transparent; }
  100% { box-shadow: 0 0 0 0 transparent; }
}

/* =========================================================
   SUCCESS PANEL
   ========================================================= */
.reg-success {
  text-align: center;
  padding: 4px 0 6px;
}

.reg-success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto 18px;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  box-shadow: 0 0 0 8px color-mix(in srgb, var(--primary) 12%, transparent);
  animation: regPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes regPop {
  from { transform: scale(0.5); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}

.reg-success p {
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin: 0 0 14px;
}

/* =========================================================
   RESPONSIVE
   ========================================================= */
@media (max-width: 480px) {
  .login-page {
    padding: 16px 12px;
  }
  .login-card,
  .login-card.is-register {
    padding: 28px 20px 22px;
    border-radius: 16px;
  }
  .login-footnote {
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .reg-progress {
    padding: 14px 10px 12px;
  }
  .reg-progress-now strong {
    display: block;
    margin: 2px 0 0;
    padding: 0;
    border: 0;
  }
  .reg-step-label {
    font-size: 10px;
  }
}

/* ---------- Trust this device ---------- */
.login-trust {
  margin: 0 0 4px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: color-mix(in srgb, var(--primary) 3%, var(--card-bg));
}

.login-trust-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--text-primary);
  -webkit-user-select: none;
          user-select: none;
}

/* Custom checkbox: fixed size, vertically centered with the label */
.login-trust-input {
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  margin: 0;
  border: 2px solid var(--border);
  border-radius: 5px;
  background: var(--card-bg);
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.login-trust-input:hover {
  border-color: var(--primary);
}

.login-trust-input:checked {
  background: var(--primary);
  border-color: var(--primary);
}

/* checkmark */
.login-trust-input:checked::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 45%;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: translate(-50%, -50%) rotate(45deg);
}

.login-trust-input:focus-visible {
  outline: none;
  box-shadow: 0 0 0 0.2rem color-mix(in srgb, var(--primary) 25%, transparent);
}

.login-trust-hint {
  margin: 4px 0 0 28px;
  font-size: 11.5px;
  line-height: 1.4;
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA;;;;;8DAK8D;AAC9D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB;;;iFAG+E;AACjF;;AAEA;EACE;;;mFAGiF;AACnF;;AAEA;;;;8DAI8D;AAC9D;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,uEAAuE;EACvE,uBAAuB;EACvB,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,oEAAoE;AACtE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,qCAAqC;AACrC;EACE,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;8DAE8D;AAC9D;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;EAC1B,2CAA2C;EAC3C,uCAAuC;EACvC,UAAU;EACV,6EAA6E;AAC/E;;AAEA;;EAEE,UAAU;EACV,6EAA6E;AAC/E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;8DAE8D;AAC9D;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,kFAAkF;;EAElF,4BAA4B;EAC5B,sCAAsC;EACtC,wCAAwC;EACxC,kDAAkD;EAClD,yCAAyC;EACzC,mDAAmD;EACnD,iDAAiD;AACnD;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,+EAA+E;AACjF;;AAEA;;;;EAIE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,aAAa;EACb,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,eAAe;AACjB;AACA,yBAAyB,0BAA0B,EAAE;AACrD;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;8DAE8D;AAC9D;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,2BAA2B,0BAA0B,EAAE;AACvD,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;EACf,wBAAwB;AAC1B;AACA,sBAAsB,qBAAqB,EAAE,cAAc,EAAE;;AAE7D;;;;;8DAK8D;AAC9D;EACE,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,qCAAqC;EAChD,qCAAqC;EACrC,sCAAsC;EACtC,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oEAAoE;EACpE,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,WAAW;EACX;wBACsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO,uEAAuE,EAAE;EAChF,OAAO,iCAAiC,EAAE;EAC1C,OAAO,+BAA+B,EAAE;AAC1C;;AAEA;;8DAE8D;AAC9D;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qEAAqE;EACrE,yEAAyE;EACzE,6DAA6D;AAC/D;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,mBAAmB,IAAI,UAAU,EAAE;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE;IACE,kBAAkB;EACpB;EACA;;IAEE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf;yBACuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,4EAA4E;AAC9E;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":["/* =========================================================\n   PAGE SHELL\n   min-height (not height) so tall forms scroll naturally, and the\n   decorative background lives on a fixed layer so it always covers\n   the whole viewport no matter how far you scroll.\n   ========================================================= */\n.login-page {\n  position: relative;\n  min-height: 100vh;\n  min-height: 100dvh;\n  width: 100%;\n  display: flex;\n  padding: 32px 16px;\n  background: var(--background);\n  isolation: isolate;\n}\n\n.login-page::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  z-index: -1;\n  pointer-events: none;\n  background:\n    radial-gradient(60% 50% at 12% 8%, rgba(200, 16, 46, 0.14), transparent 70%),\n    radial-gradient(55% 45% at 90% 92%, rgba(200, 16, 46, 0.10), transparent 70%),\n    radial-gradient(40% 30% at 85% 10%, rgba(125, 10, 31, 0.06), transparent 70%);\n}\n\n[data-theme=\"dark\"] .login-page::before {\n  background:\n    radial-gradient(60% 50% at 12% 8%, rgba(255, 113, 128, 0.16), transparent 70%),\n    radial-gradient(55% 45% at 90% 92%, rgba(255, 113, 128, 0.10), transparent 70%),\n    radial-gradient(40% 30% at 85% 10%, rgba(255, 145, 104, 0.06), transparent 70%);\n}\n\n/* =========================================================\n   CARD\n   margin: auto centers it when there's room and lets it grow\n   (and scroll) from the top when there isn't.\n   ========================================================= */\n.login-card {\n  position: relative;\n  width: 100%;\n  max-width: 420px;\n  margin: auto;\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: 20px;\n  box-shadow: 0 24px 60px -12px var(--shadow-lg), 0 2px 6px var(--shadow);\n  padding: 36px 34px 26px;\n  overflow: hidden;\n  animation: loginCardIn 0.45s cubic-bezier(0.22, 0.61, 0.36, 1) both;\n}\n\n/* brand accent strip */\n.login-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--primary), var(--secondary));\n}\n\n.login-card.is-register {\n  max-width: 460px;\n}\n\n@keyframes loginCardIn {\n  from { opacity: 0; transform: translateY(14px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* each step re-mounts and fades in */\n.login-step {\n  animation: loginStepIn 0.32s ease both;\n}\n\n@keyframes loginStepIn {\n  from { opacity: 0; transform: translateX(10px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n/* =========================================================\n   HEADER\n   ========================================================= */\n.login-brand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 14px;\n}\n\n.login-brand-icon {\n  width: 84px;\n  height: 84px;\n  object-fit: contain;\n}\n\n.login-title {\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  text-align: center;\n  margin: 0 0 6px;\n  color: var(--text-primary);\n}\n\n.login-subtitle {\n  font-size: 14px;\n  text-align: center;\n  color: var(--text-secondary);\n  margin: 0 0 22px;\n}\n\n.login-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 6px;\n}\n\n/* =========================================================\n   INPUTS\n   ========================================================= */\n.login-page .form-control {\n  min-height: 46px;\n  border-radius: var(--radius-md);\n  background-color: var(--card-bg) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n.login-page .form-control::placeholder {\n  color: var(--text-muted);\n}\n\n.login-page .form-control:focus,\n.login-page .form-select:focus {\n  color: var(--text-primary);\n  background-color: var(--card-bg) !important;\n  border-color: var(--primary) !important;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem color-mix(in srgb, var(--primary) 20%, transparent);\n}\n\n.login-page .btn:focus,\n.login-page .btn:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem color-mix(in srgb, var(--primary) 25%, transparent);\n}\n\n.login-hint {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--text-muted);\n  margin: 0 0 16px;\n}\n\n.login-sent-to {\n  font-size: 14px;\n  color: var(--text-secondary);\n  text-align: center;\n  margin: 0 0 18px;\n  word-break: break-word;\n}\n.login-sent-to strong {\n  color: var(--text-primary);\n}\n\n.login-code-input {\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.5em;\n  padding-left: 0.5em;\n}\n\n/* =========================================================\n   SUBMIT BUTTON\n   ========================================================= */\n.login-submit-btn {\n  width: 100%;\n  min-height: 48px;\n  margin-top: 8px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  border-radius: var(--radius-md);\n  transition: transform 0.08s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n\n  --cui-btn-bg: var(--primary);\n  --cui-btn-border-color: var(--primary);\n  --cui-btn-hover-bg: var(--primary-hover);\n  --cui-btn-hover-border-color: var(--primary-hover);\n  --cui-btn-active-bg: var(--primary-hover);\n  --cui-btn-active-border-color: var(--primary-hover);\n  --cui-btn-focus-shadow-rgb: var(--bs-primary-rgb);\n}\n\n.login-submit-btn,\n.login-submit-btn:hover,\n.login-submit-btn:active,\n.login-submit-btn:focus,\n.login-submit-btn:focus-visible {\n  color: #fff !important;\n}\n\n.login-submit-btn {\n  background-color: var(--primary) !important;\n  border-color: var(--primary) !important;\n  box-shadow: 0 8px 18px -8px color-mix(in srgb, var(--primary) 70%, transparent);\n}\n\n.login-submit-btn:hover,\n.login-submit-btn:active,\n.login-submit-btn:focus,\n.login-submit-btn:focus-visible {\n  background-color: var(--primary-hover) !important;\n  border-color: var(--primary-hover) !important;\n}\n\n.login-submit-btn:active:not(:disabled) {\n  transform: translateY(1px);\n}\n\n.login-submit-btn:disabled {\n  background-color: var(--primary) !important;\n  border-color: var(--primary) !important;\n  opacity: 0.55;\n  box-shadow: none;\n}\n\n/* =========================================================\n   PASSWORD FIELD\n   ========================================================= */\n.password-input-wrapper {\n  position: relative;\n  margin-bottom: 1.25rem;\n}\n\n.password-input {\n  padding-right: 44px;\n}\n\n.password-toggle {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.password-toggle:hover { color: var(--text-primary); }\n.password-toggle:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/* =========================================================\n   LINKS / FOOTER\n   ========================================================= */\n.login-switch {\n  text-align: center;\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin: 16px 0 0;\n}\n\n.login-switch-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.login-switch-link:hover { text-decoration: underline; }\n.login-switch-link:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.login-footnote {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 24px -34px 0;\n  padding: 14px 34px 0;\n  border-top: 1px solid var(--border);\n  font-size: 12px;\n  color: var(--text-muted);\n}\n.login-footnote svg { color: var(--primary); flex-shrink: 0; }\n\n/* =========================================================\n   REGISTRATION PROGRESS (stepper)\n   The line runs from the CENTER of the first dot to the CENTER of\n   the last dot (inset = half of one column), so a fill of\n   index / (steps - 1) lands exactly on the active dot.\n   ========================================================= */\n.reg-progress {\n  margin: 0 0 26px;\n  padding: 16px 16px 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: color-mix(in srgb, var(--primary) 3%, var(--card-bg));\n}\n\n.reg-progress-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.reg-progress-now {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.reg-progress-now strong {\n  margin-left: 8px;\n  padding-left: 8px;\n  border-left: 1px solid var(--border);\n  color: var(--text-primary);\n  letter-spacing: 0.02em;\n}\n\n.reg-progress-pct {\n  font-size: 13px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: var(--primary);\n}\n\n.reg-stepper {\n  position: relative;\n}\n\n.reg-stepper-line {\n  position: absolute;\n  top: 10px; /* vertical center of the 20px dots */\n  left: calc(100% / (var(--steps) * 2));\n  right: calc(100% / (var(--steps) * 2));\n  height: 4px;\n  transform: translateY(-50%);\n  border-radius: 999px;\n  background: var(--border);\n  overflow: hidden;\n}\n\n.reg-stepper-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, var(--primary), var(--secondary));\n  transition: width 0.6s cubic-bezier(0.22, 0.61, 0.36, 1);\n}\n\n.reg-stepper-list {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: repeat(var(--steps), 1fr);\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.reg-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.reg-step-dot {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid var(--border);\n  background: var(--card-bg);\n  color: #fff;\n  transition: background-color 0.3s ease, border-color 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.reg-step-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-align: center;\n  white-space: nowrap;\n  transition: color 0.3s ease;\n}\n\n/* completed */\n.reg-step.is-complete .reg-step-dot {\n  background: var(--primary);\n  border-color: var(--primary);\n}\n.reg-step.is-complete .reg-step-label {\n  color: var(--text-secondary);\n}\n\n/* current */\n.reg-step.is-current .reg-step-dot {\n  border-color: var(--primary);\n  background: var(--card-bg);\n  animation: regPulse 2s ease-out infinite;\n}\n.reg-step.is-current .reg-step-dot::after {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--primary);\n}\n.reg-step.is-current .reg-step-label {\n  color: var(--primary);\n}\n\n@keyframes regPulse {\n  0%   { box-shadow: 0 0 0 0 color-mix(in srgb, var(--primary) 40%, transparent); }\n  70%  { box-shadow: 0 0 0 8px transparent; }\n  100% { box-shadow: 0 0 0 0 transparent; }\n}\n\n/* =========================================================\n   SUCCESS PANEL\n   ========================================================= */\n.reg-success {\n  text-align: center;\n  padding: 4px 0 6px;\n}\n\n.reg-success-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 18px;\n  border-radius: 50%;\n  color: #fff;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  box-shadow: 0 0 0 8px color-mix(in srgb, var(--primary) 12%, transparent);\n  animation: regPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n@keyframes regPop {\n  from { transform: scale(0.5); opacity: 0; }\n  to   { transform: scale(1);   opacity: 1; }\n}\n\n.reg-success p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n  margin: 0 0 14px;\n}\n\n/* =========================================================\n   RESPONSIVE\n   ========================================================= */\n@media (max-width: 480px) {\n  .login-page {\n    padding: 16px 12px;\n  }\n  .login-card,\n  .login-card.is-register {\n    padding: 28px 20px 22px;\n    border-radius: 16px;\n  }\n  .login-footnote {\n    margin-left: -20px;\n    margin-right: -20px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .reg-progress {\n    padding: 14px 10px 12px;\n  }\n  .reg-progress-now strong {\n    display: block;\n    margin: 2px 0 0;\n    padding: 0;\n    border: 0;\n  }\n  .reg-step-label {\n    font-size: 10px;\n  }\n}\n\n/* ---------- Trust this device ---------- */\n.login-trust {\n  margin: 0 0 4px;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: color-mix(in srgb, var(--primary) 3%, var(--card-bg));\n}\n\n.login-trust-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--text-primary);\n  user-select: none;\n}\n\n/* Custom checkbox: fixed size, vertically centered with the label */\n.login-trust-input {\n  appearance: none;\n  -webkit-appearance: none;\n  position: relative;\n  flex: 0 0 18px;\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  border: 2px solid var(--border);\n  border-radius: 5px;\n  background: var(--card-bg);\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.login-trust-input:hover {\n  border-color: var(--primary);\n}\n\n.login-trust-input:checked {\n  background: var(--primary);\n  border-color: var(--primary);\n}\n\n/* checkmark */\n.login-trust-input:checked::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 45%;\n  width: 4px;\n  height: 8px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.login-trust-input:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 0.2rem color-mix(in srgb, var(--primary) 25%, transparent);\n}\n\n.login-trust-hint {\n  margin: 4px 0 0 28px;\n  font-size: 11.5px;\n  line-height: 1.4;\n  color: var(--text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
